var TYPE;
(function (TYPE) {
    TYPE[TYPE["NO_VERIFY"] = 0] = "NO_VERIFY";
    TYPE[TYPE["SLIDE"] = 1] = "SLIDE";
    TYPE[TYPE["IMAGE"] = 2] = "IMAGE"; // 图片验证码
})(TYPE || (TYPE = {}));
;
var ERROR_MESSAGE;
(function (ERROR_MESSAGE) {
    // 滑块降级
    ERROR_MESSAGE["NEED_DOWN_GRADE"] = "NEED_DOWN_GRADE";
    ERROR_MESSAGE["INIT_CAPTCHA_ERROR"] = "INIT_CAPTCHA_ERROR";
    ERROR_MESSAGE["TENCENT_CAPTCHA_ERROR"] = "TENCENT_CAPTCHA_ERROR";
    ERROR_MESSAGE["LOAD_CAPCHA_JS_ERROR"] = "LOAD_CAPCHA_JS_ERROR";
    // 加载失败
    ERROR_MESSAGE["REQUEST_IMAGE_CODE_ERROR"] = "REQUEST_IMAGE_CODE_ERROR"; // 请求滑块验证码错误
})(ERROR_MESSAGE || (ERROR_MESSAGE = {}));
;
var ENV;
(function (ENV) {
    ENV["DEV"] = "dev";
    ENV["TEST"] = "test";
    ENV["PRO"] = "pro";
})(ENV || (ENV = {}));
;
export { TYPE, ERROR_MESSAGE, ENV };
//# sourceMappingURL=const.js.map